<div class="file-upload-container upload-box">
  <p-toast></p-toast>

  <p-fileUpload #fileUploader name="myfile[]" [multiple]="true" [customUpload]="true" (onSelect)="onFileSelect($event)">
    <ng-template pTemplate="header" let-chooseCallback="chooseCallback">
      <div class="upload-header" (click)="triggerFileUpload()">
        <i class="pi pi-cloud-upload"></i>
        <span>
          <span class="clickToUpload">Click to upload </span>
          <span class="dragDrop">or Drag & Drop</span>
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="content" let-files>
      <div class="row mt-3 g-2">
        <div
          [ngClass]="{'col-12': allUploadedFiles?.length <= 1, 'col-xl-4 col-md-6 col-sm-6 col-12': allUploadedFiles.length > 1}"
          *ngFor="let file of allUploadedFiles; let i = index">
          <div class="file-preview">
            <div class="file-info">
              <!-- File Icon Logic Based on File Type -->
              <!-- File Icon Logic Based on File Type -->
              @if (file?.type?.includes('pdf') || file?.name?.endsWith('.pdf')) {
              <img class="fit-object-cover" src="assets/images/icons/pdficon.svg" alt="PDF Icon" />
              }
              @else if ( file?.name?.includes('.doc')|| file?.name?.includes('.docx')) {
              <!-- Word Document Icon -->
              <img class="fit-object-cover" src="assets/images/icons/attachment-file.svg" alt="Word Icon" />
              }
              @else if (file?.type?.includes('excel') || file?.type === 'application/vnd.ms-excel' ||
              file?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
              file?.name?.includes('.xls') || file?.name?.includes('.xlsx') ||
              file?.name?.includes('.XLS') || file?.name?.includes('.XLSX')) {
              <!-- Excel File Icon -->
              <img class="fit-object-cover" src="assets/images/icons/attachment-xlsx.svg" alt="Excel Icon" />
              }
              @else if (file?.type?.includes('image')) {
              <!-- Image Preview -->
              <img role="presentation" class="loaded" [alt]="file.name"
                [src]="file.objectURL ?? 'assets/images/icons/attachment-image.svg'" width="50" height="50" />
              }
              @else {
              <!-- Default File Icon -->
              <img class="fit-object-cover" src="assets/images/icons/attachments.svg" alt="File Icon" />
              }
              <div class="file-details">
                <span class="file-name">{{ truncateFileName(file.name) }}</span>
                <span class="file-size">{{ formatSizeUnits(file.size) }}</span>
              </div>
            </div>
            <button type="button" class="btn file-delete border-0" (click)="removeFile(file, i)">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>
</div>